export default __webpack_public_path__ + "static/media/Background 5_00055.7927deec.png";